import { render, staticRenderFns } from "./CopySitetypeDialog.vue?vue&type=template&id=4ba181b9&scoped=true"
import script from "./CopySitetypeDialog.vue?vue&type=script&lang=js"
export * from "./CopySitetypeDialog.vue?vue&type=script&lang=js"
import style0 from "./CopySitetypeDialog.vue?vue&type=style&index=0&id=4ba181b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba181b9",
  null
  
)

export default component.exports